/**
 * Building detail information for tech tree panel tooltips.
 * Maps each BuildingKind to its display name, description, inputs, outputs,
 * duration, and category. Source of truth: rex-game-design building table.
 */

import { BuildingKind, TechStage } from './client_message_protocol';

export interface BuildingDetailInfo {
  name: string;
  description: string;
  inputs: string;
  outputs: string;
  duration: string;
  category: string;
}

export const BUILDING_DETAILS: Partial<Record<BuildingKind, BuildingDetailInfo>> = {
  [BuildingKind.SpiritRoot]: {
    name: '灵根',
    description: '聚天地灵气，一切生产之根基',
    inputs: '无',
    outputs: '灵气',
    duration: '3s',
    category: '生产',
  },
  [BuildingKind.GatheringArray]: {
    name: '采集阵',
    description: '消耗灵气凝结为灵石',
    inputs: '灵气×1',
    outputs: '灵石',
    duration: '5s',
    category: '生产',
  },
  [BuildingKind.HerbFarm]: {
    name: '药田',
    description: '种植灵草，用于炼丹',
    inputs: '无',
    outputs: '草药',
    duration: '8s',
    category: '生产',
  },
  [BuildingKind.TransporterStation]: {
    name: '搬运站',
    description: '部署搬运傀儡，加速目标建筑生产',
    inputs: '无',
    outputs: '加速',
    duration: '持续',
    category: '物流',
  },
  [BuildingKind.RefiningArray]: {
    name: '精炼阵',
    description: '辅助型阵法，提升相邻建筑效率',
    inputs: '—',
    outputs: '—',
    duration: '—',
    category: '辅助',
  },
  [BuildingKind.AlchemyFurnace]: {
    name: '丹炉',
    description: '消耗灵石炼制丹药',
    inputs: '灵石×2',
    outputs: '丹药×1',
    duration: '12s',
    category: '生产',
  },
  [BuildingKind.Forge]: {
    name: '锻造台',
    description: '消耗灵石锻造法器',
    inputs: '灵石×5',
    outputs: '法器×1',
    duration: '20s',
    category: '生产',
  },
  [BuildingKind.SwordTower]: {
    name: '剑塔',
    description: '对范围内的敌人造成伤害',
    inputs: '—',
    outputs: '范围伤害',
    duration: '持续',
    category: '战斗',
  },
  [BuildingKind.SlowTrap]: {
    name: '减速陷阱',
    description: '减缓范围内敌人的移动速度',
    inputs: '—',
    outputs: '减速',
    duration: '持续',
    category: '战斗',
  },
  [BuildingKind.PuppetWorkshop]: {
    name: '傀儡坊',
    description: '消耗灵石制造傀儡核心',
    inputs: '灵石×5',
    outputs: '傀儡核心×1',
    duration: '15s',
    category: '生产',
  },
  [BuildingKind.PuppetBarracks]: {
    name: '傀儡营',
    description: '消耗傀儡核心召唤战斗傀儡',
    inputs: '傀儡核心×1',
    outputs: '战斗傀儡',
    duration: '20s',
    category: '战斗',
  },
  [BuildingKind.DefenseTower]: {
    name: '防御塔',
    description: '自动攻击范围内敌方单位',
    inputs: '—',
    outputs: '范围攻击',
    duration: '持续',
    category: '战斗',
  },
};

/** Get the Chinese stage label for unlock display */
export function stageLabel(stage: TechStage): string {
  switch (stage) {
    case TechStage.Foundation: return '筑基期';
    case TechStage.GoldenCore: return '金丹期';
    case TechStage.NascentSoul: return '元婴期';
    default: return stage;
  }
}
